"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentHistoryType = void 0;
var DocumentHistoryType;
(function (DocumentHistoryType) {
    DocumentHistoryType["CREATED"] = "CREATED";
    DocumentHistoryType["SAVED_AS_DRAFT"] = "SAVED_AS_DRAFT";
    DocumentHistoryType["SUBMITTED"] = "SUBMITTED";
    DocumentHistoryType["REHUDDLE"] = "REHUDDLE";
    DocumentHistoryType["DELETE"] = "DELETE";
    DocumentHistoryType["AUTO_SYNC"] = "AUTO_SYNC";
})(DocumentHistoryType = exports.DocumentHistoryType || (exports.DocumentHistoryType = {}));
//# sourceMappingURL=documentHistoryType.js.map